<template lang="html">
  <div class="_ipbookingform global__scrollcustom"
    v-if="queryData">
    <form  @submit.prevent="handleSubmit" action="" method="">
    <div class="_ipbookingform__wrapper">
      <InfoHeader class="_ipbookingform__wrapper--header"></InfoHeader>
      <div class="_ipbookingform__wrapper--content">
        <div class="_content">
          <!-- <b-form @submit="handleSubmit" v-if="show"> -->
            <h4>Shipper Details</h4>
            <div class="row mb-5">
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Shipper PIC Name "
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.shipper_name"
                    v-validate="'required'"
                    name="shipper_name"
                    type="text"
                    required
                    placeholder="Insert Shipper PIC Full Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Phone"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.shipper_phone"
                    v-validate="'required'"
                    name="shipper_phone"
                    type="number"
                    required
                    placeholder="Shipper PIC Phone Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="ZIP Code"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="shipper_zipcode"
                    v-model="form.shipper_zip_code"
                    type="number"
                    required
                    placeholder="Shipper ZIP Code Number"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Company Name"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.shipper_comp"
                    v-validate="'required'"
                    name="shipper_comp"
                    type="text"
                    required
                    placeholder="Shipper Company Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1">
                  <div class="row m-0 justify-content-between align-items-end">
                     <label>Company Tax ID</label>
                     <small class="mb-2">*Optional</small>
                  </div>
                  <b-form-input
                    name="shipper_taxid"
                    type="text"
                    v-model="form.shipper_company_tax_id"
                    placeholder="Shipper Company Tax ID"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Company Address"
                  label-for="input-1" >
                  <b-form-textarea
                  id="textarea"
                  v-model="form.shipper_address"
                  v-validate="'required'"
                  name="shipper_address"
                  placeholder="Shipper Company Address"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <!-- end Shipper Details -->
            <h4>Consignee Details</h4>
            <div class="row mb-4">
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Consignee PIC Name "
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.consignee_name"
                    v-validate="'required'"
                    name="consignee_name"
                    type="text"
                    required
                    placeholder="Insert Consignee PIC Full Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Phone"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.consignee_phone"
                    v-validate="'required'"
                    name="consignee_phone"
                    type="number"
                    required
                    placeholder="Consignee PIC Phone Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="ZIP Code"
                  label-for="input-1">
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="consignee_zipcode"
                    v-model="form.consignee_zip_code"
                    type="number"
                    required
                    placeholder="Consignee ZIP Code Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="form.notifiy_party_same_consignee"
                  name="checkbox-1"
                  class="mt-4"
                  :value="1"
                  :unchecked-value="0"
                >
                  *Notify party is the same with consignee details
                </b-form-checkbox>
              </div>
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Company Name"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.consignee_comp"
                    v-validate="'required'"
                    name="consignee_comp"
                    type="text"
                    required
                    placeholder="Consignee Company Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label-for="input-1" >
                  <div class="row m-0 justify-content-between align-items-end">
                     <label>Company Tax ID</label>
                     <small class="mb-2">*Optional</small>
                  </div>
                  <b-form-input
                    id="input-1"
                    name="consignee_taxid"
                    type="text"
                    v-model="form.consignee_company_tax_id"
                    placeholder="Consignee Company Tax ID"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Company Address"
                  label-for="input-1" >
                  <b-form-textarea
                  id="textarea"
                  v-model="form.consignee_address"
                  name="consignee_address"
                  v-validate="'required'"
                  placeholder="Consignee Company Address"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <!-- Consignee Details -->
            <h4 v-if="form.notifiy_party_same_consignee === 0">Notify Party Details</h4>
            <div v-if="form.notifiy_party_same_consignee === 0" class="row mb-4">
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Notify Party PIC Name "
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.notifiy_party_name"
                    v-validate="'required'"
                    name="consignee_name"
                    type="text"
                    required
                    placeholder="Insert Notify Party PIC Full Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Phone"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.notifiy_party_phone"
                    v-validate="'required'"
                    name="consignee_phone"
                    type="number"
                    required
                    placeholder="Notify Party PIC Phone Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="ZIP Code"
                  label-for="input-1">
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="consignee_zipcode"
                    v-model="form.notifiy_party_zip_code"
                    type="number"
                    required
                    placeholder="Notify Party ZIP Code Number"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Company Name"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="form.notifiy_party_comp"
                    v-validate="'required'"
                    name="consignee_comp"
                    type="text"
                    required
                    placeholder="Notify Party Company Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label-for="input-1" >
                  <div class="row m-0 justify-content-between align-items-end">
                     <label>Company Tax ID</label>
                     <small class="mb-2">*Optional</small>
                  </div>
                  <b-form-input
                    id="input-1"
                    name="consignee_taxid"
                    v-model="form.notifiy_party_company_tax_id"
                    type="text"
                    placeholder="Notify Party Company Tax ID"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Company Address"
                  label-for="input-1" >
                  <b-form-textarea
                  id="textarea"
                  v-model="form.notifiy_party_address"
                  name="consignee_address"
                  v-validate="'required'"
                  placeholder="Notify Party Company Address"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                </b-form-group>
              </div>
            </div>

            <h4>Shipper Notes</h4>
            <div class="col-md p-0">
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                description="*Optional">
                  <b-form-textarea
                    id="textarea"
                    v-model="form.shipper_notes"
                    name="shipper_notes"
                    placeholder="e.g : 'cargo can't be stacked, cargo load into lower deck.'"
                    rows="4"
                    max-rows="6">
                  </b-form-textarea>
              </b-form-group>
            </div>
          <!-- </b-form> -->
        </div>
      </div>
     </div>
    </form>
  </div>
</template>

<script>
import InfoHeader from '@/components/requestList/requestStatusContract/InfoHeader'
import { mapGetters } from 'vuex'
import * as moment from 'moment'

export default {
  name: 'ContractBookingForm',
  components: {
    InfoHeader
  },
  data () {
    return {
      form: {
        shipper_name: '',
        shipper_comp: '',
        shipper_address: '',
        shipper_phone: '',
        shipper_email: 'email@email.com',
        shipper_zip_code: '',
        shipper_company_tax_id: '',
        consignee_name: '',
        consignee_comp: '',
        consignee_address: '',
        consignee_phone: '',
        consignee_zip_code: '',
        consignee_company_tax_id: '',
        notifiy_party_comp: '',
        notifiy_party_name: '',
        notifiy_party_address: '',
        notifiy_party_phone: '',
        notifiy_party_zip_code: '',
        notifiy_party_company_tax_id: '',
        notifiy_party_same_consignee: 1,
        shipper_notes: '',
        consignee_email: 'email@email.com'
      },
      quote: {},
      query: {
        form: {}
      },
      show: true
    }
  },
  computed: {
    ...mapGetters({
      queryData: 'book/dataTemp'
    }),
    ...mapGetters({
      auth: 'auth/profile',
      authError: 'auth/error',
      authIsLoading: 'auth/isLoading'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let temp = this.form
      let auth = this.auth
      const contractData = this.queryData.contract

      if (auth) {
        // import
        if (contractData.country_to === 'IDN' || auth.companyHeadQuarter === contractData.country_to) {
          temp.consignee_name = auth.customerName
          temp.consignee_comp = auth.companyName
          temp.consignee_address = auth.companyAddress
          temp.consignee_phone = auth.customerPhone
          temp.book_type = 'import'
        } else {
          temp.shipper_name = auth.customerName
          temp.shipper_comp = auth.companyName
          temp.shipper_address = auth.companyAddress
          temp.shipper_phone = auth.customerPhone
          temp.book_type = 'export'
        }
      }

      this.auth && Object.assign(temp, auth)
    },
    placeOrder: function () {
      this.$eventHub.$emit('dialog-requestlist-form')
    },
    handleSubmit (e) {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const contractData = this.queryData.contract
          const bidData = this.queryData.bid
          // form
          this.form.book_price_currency_code = 'IDR'
          this.form.commodities_class = 'GENCO'
          this.form.commodities_type = contractData.product_type
          this.form.goodsValue = contractData.total_price
          this.form.commodities_hscode = (contractData.hs_code === null) ? '' : contractData.hs_code
          this.form.commodities_product = contractData.description
          this.form.incoterms = contractData.incoterms
          this.form.book_type = 'export'
          this.form.reference_number = contractData.contract_number
          this.form.pickup_address = contractData.pickup_address
          this.form.delivery_address = contractData.delivery_address
          this.form.shipment = contractData.optiontp
          this.form.status_shipment = 2
          this.form.termofpayment = contractData.term_of_payment
          this.form.contract_number = contractData.contract_number
          this.form.id_contract = contractData.id

          // quote
          this.quote.vendor_id = bidData.id_merchant
          this.quote.vendor_name = bidData.compname
          this.quote.carrier_name = bidData.shippingline
          this.quote.origin_country_code = contractData.country_from
          this.quote.origin_country = contractData.countryf
          this.quote.origin_city_code = contractData.city_from
          this.quote.origin_city = contractData.cityf
          this.quote.destination_country_code = contractData.country_to
          this.quote.destination_country = contractData.countryt
          this.quote.destination_city_code = contractData.city_to
          this.quote.destination_city = contractData.cityt
          this.quote.valid_until = bidData.validdate
          this.quote.transittime_max = bidData.estimatedaymax
          this.quote.transittime_min = bidData.estimatedaymin
          this.quote.price_total = bidData.bid
          this.quote.price_currency_code = 'IDR'
          this.quote.orderPriceCurrencyRate = 1
          this.quote.freight_mode = contractData.service_head
          this.quote.freight_type = contractData.shipment_type
          this.quote.hsCode = contractData.hs_code
          this.quote.dimension = contractData.dimension
          this.quote.productType = contractData.description
          this.quote.goodsValue = contractData.total_price
          this.quote.description = contractData.description
          this.quote.incoterms = contractData.incoterms
          this.quote.id_contract = contractData.id
          this.quote.bidId = bidData.id
          this.quote.rfqStatus = false
          this.quote.reference_number = contractData.contract_number
          this.quote.pickup_address = contractData.pickup_address
          this.quote.delivery_address = contractData.delivery_address
          this.quote.optiontp = contractData.optiontp
          this.quote.status_shipment = 2
          this.quote.orderPriceFreight = []
          this.quote.orderPriceDocument = []
          this.quote.orderPriceCustom = []
          this.quote.orderPriceTrucking = []
          this.quote.orderPriceInsurance = []
          this.quote.orderPriceOrigin = []
          this.quote.orderPriceDestination = []
          this.quote.freight_direct = false
          let load
          if (contractData.shipment_type && contractData.shipment_type.includes('SEAFCL')) {
            load = 'fcl'
          } else if (contractData.shipment_type === 'SEALCL') {
            load = 'lcl'
          } else {
            load = contractData.shipment_type
          }

          // query
          this.query.shipmentLoad = load
          // query form
          this.query.form.datePickup = moment(contractData.cargo_readynes_date).format('DD/MM/YY')
          this.query.form.originCity = contractData.city_from
          this.query.form.originCountry = contractData.country_from
          this.query.form.destinationCity = contractData.city_to
          this.query.form.destinationCountry = contractData.country_to
          this.query.form.loadsFCL = [
            {
              qty: contractData.total_quantity,
              size: '',
              type: 'container',
              weight: 'standard'
            }
          ]
          this.query.form.loadsLCL = [
            {
              qty: contractData.total_quantity,
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: contractData.satuan,
              volume: contractData.estimateddimension,
              weight: contractData.total_weight,
              weightUnit: 'kg'
            }
          ]
          this.query.form.loadsAIRCargo = [
            {
              qty: contractData.total_quantity,
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: contractData.satuan,
              volume: contractData.estimateddimension,
              weight: contractData.total_weight,
              weightUnit: 'kg'
            }
          ]
          this.query.form.loadsAIRCourier = [
            {
              qty: contractData.total_quantity,
              size: {
                length: 0,
                height: 0,
                width: 0,
                unit: 'cm'
              },
              type: contractData.satuan,
              volume: contractData.estimateddimension,
              weight: contractData.total_weight,
              weightUnit: 'kg'
            }
          ]
          const _form = {
            form: this.form,
            quote: this.quote,
            query: this.query
          }
          const contractNumber = this.form.contract_number.split('/').join('-')
          const idContract = this.form.id_contract
          await this.$store.dispatch('book/POST_DATA_BOOK', _form)
          this.$router.push({ path: `/contract-ba/${idContract}/${contractNumber}` })
          // this.$eventHub.$emit('dialog-requestlist-contract-form')
        } else {
          alert('Correct them errors!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ContractBookingForm/index.vue